import { createReducer, updateDeepState, updateState } from '../handlers'
import types from './types'

const initialState = {
  totalAssigned: 0, // Usuarios del listado de asignados con mensajes sin leer
  totalMainPool: 0, // Usuarios del listado principal con mensajes sin leer
  users: {}
}

const update = (state, action) => {
  const { userId, pendingMsgCount, assignedTo, isChannelRemove } = action.event

  const userInState = state.users[userId]
  const isAssigned = assignedTo?.includes(action.opId)

  if (isChannelRemove) {
    if (pendingMsgCount > 0) {
      state.users[userId] = { isAssigned, pendingMsgCount, isChannelRemove }

      return updateDeepState({}, state)
    }

    if (!userInState) return state

    delete state.users[userId]

    return updateDeepState({}, state)
  }

  if (userInState) {
    const isOldAssigned = userInState.isAssigned

    if (pendingMsgCount > 0) {
      if (!isOldAssigned && isAssigned) {
        state.totalAssigned += 1
        state.totalMainPool -= 1
      } else if(isOldAssigned && !isAssigned) {
        state.totalAssigned -= 1
        state.totalMainPool += 1
      }

      state.users[userId] = { isAssigned, pendingMsgCount }
    } else {
      // Not include messages, remove from state
      delete state.users[userId]
      state.totalAssigned -= isOldAssigned ? 1 : 0
      state.totalMainPool -= isOldAssigned ? 0 : 1
    }

    return updateDeepState({}, state)
  }

  // User not in state
  if (pendingMsgCount > 0) {
    state.totalAssigned += isAssigned ? 1 : 0
    state.totalMainPool += isAssigned ? 0 : 1
    state.users[userId] = { isAssigned, pendingMsgCount }

    return updateDeepState({}, state)
  }

  return state
}

const add = (state, action) => {
  const { assignedTo, mainPool, users } = action.event

  const newState = {
    totalAssigned: assignedTo || 0,
    totalMainPool: mainPool || 0,
    users: users || {}
  }

  return updateState(state, newState)
}

const seen = (state, action) => {
  const { activeUser } = action

  const userInState = state.users[activeUser]

  if (userInState) {
    const isOldAssigned = userInState.isAssigned

    delete state.users[activeUser]
    if (!userInState.isChannelRemove) {
      state.totalAssigned -= isOldAssigned ? 1 : 0
      state.totalMainPool -= isOldAssigned ? 0 : 1
    }

    return updateDeepState({}, state)
  }

  return state
}

export default createReducer(
  updateDeepState(initialState),
  {
    [types.update]: update,
    [types.seen]: seen,
    [types.add]: add,
  }
)